import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { about } from "../../portfolio";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import "./About.scss";
import Fiverr from "./fiverr.js"
import fiverr from "./fiverr.svg"

const About = () => {
  const { name, role, description, resume, social } = about;

  const handleResumeClick = async () => {
    const inputDetails = prompt("Enter your Email:");
  
    if (inputDetails) {
      // Save input details to Firebase
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputDetails)) {
        alert("Invalid email format. Please enter a valid email.");
        return;
      }
      try {
        const docRef = await addDoc(collection(db, "inputDetails"), {
          Email: inputDetails,
          Date: new Date(),
        });
        console.log("Document written with ID: ", docRef.id);
  
        // Open the link in a new tab or window when a user interaction occurs
        const link = document.createElement("a");
        link.href = 'https://drive.google.com/file/d/1Fsd2do_7raB7aPNCBesIz46nStSqsAXL';
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    }
  };
  return (
    <div className="about">
      <div className="centerflex">
        <div>
      {name && (
        <h1>
        <span className="about__name">
          <div className="carousel">
            {" "}
            <h1>Hi, I am </h1>
            <div className="change_outer">
                <div className="change_inner">
                <div className="element">Hi</div>
                  <div className="element">{name}</div>
                  <div className="element">{role}</div>
                <div className="element">MERN Developer</div>
                  <div className="element">Android Developer</div>
                  <div className="element"></div>
              </div>
            </div>
          </div>
        </span>
        </h1>
      )}
      


      
      <p className="about__desc">{description && description}</p>

      <div className="about__contact center">
        {resume && (
              <a
                // href={resume} target="_blank" rel="noreferrer"
              >
            <span type="button" className="btn btn--outline" onClick={handleResumeClick}>
              Resume
            </span>
          </a>
        )}

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label="github"
                className="link link--icon"
                target="_blank"  rel="noreferrer"
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label="linkedin"
                className="link link--icon"
                target="_blank"  rel="noreferrer"
                
              >
                <LinkedInIcon />
              </a>
                )}
                {social.fiverr && (
              <a
                href={social.fiverr}
                aria-label="fiverr"
                // className="link link--icon"
                target="_blank"  rel="noreferrer"
                  >
                    {/* <div class="logo"></div> */}
                {/* <img src="https://img.icons8.com/?size=512&id=14h574ySQ7kG&format=png" alt="fiverr"  style={{width:"40px"}} /> */}
                    <Fiverr color="#111111"/>
                {/* <img src={fiverr} alt="fiverr" className="link link--icon svg"  style={{color:"white", width:"30px"}} /> */}
              </a>
            )}
          </>
        )} 
          </div>
          </div>
      <span className="faded faded-wide faded-left faded-top"><img className="img" src="https://raw.githubusercontent.com/armemon/mywebsite/main/AR%20Memon.jpeg" /></span>
      </div></div> 
  );
};

export default About;
